import { Component, OnDestroy, OnInit, ViewChild, inject } from '@angular/core';
import { OpenClose, PopupBaseComponent } from '@app/shared/popup';
import { NgbTooltip } from '@ng-bootstrap/ng-bootstrap';
import { Subscription } from 'rxjs';
import { CompanyAdminSupportService } from './service/company-admin-support.service';

@Component({
    selector: 'app-company-admin-support-popup',
    templateUrl: './company-admin-support-popup.component.html',
    styleUrls: ['./company-admin-support-popup.component.scss'],
    animations: [OpenClose],
    providers: [CompanyAdminSupportService],
    standalone: false
})
export class CompanyAdminSupportPopupComponent extends PopupBaseComponent implements OnInit, OnDestroy {
    @ViewChild('tootlipCopySelectedEmails') public tooltip: NgbTooltip;

    private readonly companyAdminSupportService = inject(CompanyAdminSupportService);

    companyAdmins$ = this.companyAdminSupportService.companyAdmins$;
    loaded$ = this.companyAdminSupportService.loaded$;
    selectedAdminsEmails$ = this.companyAdminSupportService.selectedAdminsEmails$;

    private readonly subscriptions = new Subscription();

    ngOnInit(): void {
        this.companyAdminSupportService.init();
    }

    ngOnDestroy(): void {
        this.companyAdminSupportService.destroy();
        this.subscriptions.unsubscribe();
    }

    copySelectedEmails() {
        this.tooltip.open();
        this.companyAdminSupportService.copySelectedEmails();
    }

    onMouseLeave() {
        this.tooltip.close();
    }
}
